/**
 * Left filters panel shell: title, disabled Clear all, empty body, disabled Apply (draft/apply wiring comes later).
 */
import { observer } from "mobx-react";
import "./rma-list-filters-sidebar.scss";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import FontHeading5 from "../../../../../components/fonts/font-heading5/font-heading5";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import IconFunnel from "../../../../../components/icons/icon-funnel/icon-funnel";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

const RmaListFiltersSidebar: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    return (
        <aside className="rma-list-filters-sidebar">
            <div className="rma-list-filters-sidebar__header">
                <div className="rma-list-filters-sidebar__title-row">
                    <IconFunnel color="var(--color-primary-2)" />
                    <FontHeading5 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        {getTranslation("FILTERS_TITLE", scope)}
                    </FontHeading5>
                </div>
                <Button variant={BUTTON_VARIANTS.Text} text={getTranslation("FILTERS_CLEAR_ALL", scope)} disabled />
            </div>
            <div className="rma-list-filters-sidebar__body" aria-hidden />
            <div className="rma-list-filters-sidebar__footer">
                <Button
                    variant={BUTTON_VARIANTS.PrimaryAccent}
                    text={getTranslation("MANAGE_RETURNS_APPLY_FILTERS", scope)}
                    disabled
                />
            </div>
        </aside>
    );
});

export default RmaListFiltersSidebar;
